import React from 'react';
import './web-view.scss';
	export class ViewWeb extends React.PureComponent<any> {

	public render() {
		return <div {...this.props} className={'webViewStyle ' + this.props.className}>{this.props.children}</div>
	}
}
